"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.query = void 0;
const client_1 = require("@apollo/client");
exports.query = (0, client_1.gql) `
query notifyEvent($eventId:String,$email:String){
    notifyEvent(eventId:$eventId,email:$email){
        _id
    }
}
`;
exports.default = exports.query;
//# sourceMappingURL=notifiyEvent.js.map